import { render, staticRenderFns } from "./nftAlbum.vue?vue&type=template&id=05b4bc5c&scoped=true&"
import script from "./nftAlbum.vue?vue&type=script&lang=js&"
export * from "./nftAlbum.vue?vue&type=script&lang=js&"
import style0 from "./nftAlbum.vue?vue&type=style&index=0&id=05b4bc5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4bc5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b4bc5c')) {
      api.createRecord('05b4bc5c', component.options)
    } else {
      api.reload('05b4bc5c', component.options)
    }
    module.hot.accept("./nftAlbum.vue?vue&type=template&id=05b4bc5c&scoped=true&", function () {
      api.rerender('05b4bc5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/nftAlbum.vue"
export default component.exports